/**
 * @generated SignedSource<<330d564e052c581ffb789df9005486a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetUserNotificationPreferencesLegacyInput = {
  preferences: NotificationPreferencesInput;
  userId: string;
};
export type NotificationPreferencesInput = {
  bookingRemindersEnabled: boolean;
  bookingUpdatesEnabled: boolean;
  emailEnabled: boolean;
  eventRemindersEnabled: boolean;
  eventUpdatesEnabled: boolean;
  pushEnabled: boolean;
  smsEnabled: boolean;
};
export type useSetUserNotificationPreferencesLegacyMutation$variables = {
  input: SetUserNotificationPreferencesLegacyInput;
};
export type useSetUserNotificationPreferencesLegacyMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type useSetUserNotificationPreferencesLegacyMutation = {
  response: useSetUserNotificationPreferencesLegacyMutation$data;
  variables: useSetUserNotificationPreferencesLegacyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetUserNotificationPreferencesLegacyMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "SetUserNotificationPreferencesLegacyPayload",
        "kind": "LinkedField",
        "name": "setUserNotificationPreferencesLegacy",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSetUserNotificationPreferencesLegacyMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "SetUserNotificationPreferencesLegacyPayload",
        "kind": "LinkedField",
        "name": "setUserNotificationPreferencesLegacy",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d801c165affd6b11312f062e19a7c8ff",
    "id": null,
    "metadata": {},
    "name": "useSetUserNotificationPreferencesLegacyMutation",
    "operationKind": "mutation",
    "text": "mutation useSetUserNotificationPreferencesLegacyMutation(\n  $input: SetUserNotificationPreferencesLegacyInput!\n) {\n  responsePayload: setUserNotificationPreferencesLegacy(input: $input) {\n    success\n    errors {\n      __typename\n      code\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba87227f0afd328589574becab31df3a";

export default node;
